import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-global-snipper',
  templateUrl: './global-snipper.component.html',
  styleUrls: ['./global-snipper.component.scss']
})
export class GlobalSnipperComponent {
  @Input() spinnerText: string = "Searching...";

  constructor() { }

  ngOnInit() {}
}
